module.exports = __webpack_public_path__ + "img/识别异常.16fd4f21.png";